import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import Slider from "react-slick";

export const MultiQuote = (props) => {

    const sc = props.slice.primary;

    const quotes = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    const settings = {
        dots: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 500,
        pauseOnHover: true,
        arrows: true,
        nextArrow: <div><i className="fa-solid fa-chevron-right text-grey text-3xl cursor-pointer relative md:-top-8" /></div>,
        prevArrow: <div><i className="fa-solid fa-chevron-left text-grey text-3xl cursor-pointer relative md:-top-8" /></div>,
        className: "quote-tabs",
        
      };

      
    return (
        <section className={"textblock relative bg-" + (bg) + " " + (space)}>
        <div className="relative m-auto max-w-5xl w-11/12">
                <div className="w-auto m-auto items-center md:w-11/12">
                <Slider {...settings}>
                {quotes.map(quote => {
                    return (
                        
                            <div>
                                <div className={"quotey text-" + sc.theme}><i className="fa-solid fa-quote-left text-4xl md:text-6xl"></i></div>
                                <div className="text-base md:text-xl mb-8 text-grey"><PrismicRichText field={quote.quote.richText} /></div>
                                <div>
                                <strong className="mt-4 block">{quote.author}</strong>
                                <span className="block text-base">{quote.author_meta}</span>
                                </div>
                            </div>
                        
                    )
                })}
                </Slider>
                </div>
            </div>
        </section>
    );
}

